export default __webpack_public_path__ + "static/media/0x8f9e8e833a69aa467e42c46cca640da84dd4585f.c697736f.webp";